import React, { useContext } from 'react'
import { HostServices } from '@ally/federated-types'
import { Domain, LoadState } from '@ally/use-data-domain'
import { Domains } from '@ally/data-types-host'

const noop = ((): void => {
  /* noop */
}) as any

const unloadedDomain = (): Domain<any> => ({
  data: null,
  error: null,
  status: { loadState: LoadState.UNLOADED, timeStamp: new Date() },
  update: noop,
  response: null,
})

export const defaultHostServices = (): HostServices => ({
  analytics: {
    mountDigitalDataObject: noop,
    trackEvent: noop,
    trackPageView: noop,
    trackImpression: noop,
  },
  env: {
    isDev: false,
    isDevLike: false,
    isEmulator: false,
    isLocal: false,
    isProd: false,
    isQA: false,
    name: '',
    pick: noop,
    prod: { C: false, D: false },
  },
  featureFlags: {
    loadState: LoadState.UNLOADED,
    waitUntilGoalsReady: noop,
    waitUntilReady: noop,
    waitForInitialization: noop,
    identify: noop,
    getUser: noop,
    flush: noop,
    variation: noop,
    variationDetail: noop,
    setStreaming: noop,
    on: noop,
    off: noop,
    track: noop,
    allFlags: noop,
    close: noop,
    alias: noop,
  },
  hostData: {
    [Domains.ACCOUNTS]: unloadedDomain(),
    [Domains.AFG_ACCOUNTS]: unloadedDomain(),
    [Domains.AFG_CUSTOMER]: unloadedDomain(),
    [Domains.BAD_WORDS]: unloadedDomain(),
    [Domains.CUSTOMER]: unloadedDomain(),
    [Domains.CUSTOMER_INFO]: unloadedDomain(),
    [Domains.CUSTOMIZATION]: unloadedDomain(),
    [Domains.MESSAGE_COUNT]: unloadedDomain(),
    [Domains.RESTRICTED_DATES]: unloadedDomain(),
    [Domains.TRANSFER_ACCOUNTS]: unloadedDomain(),
  },
  log: {
    track: noop,
    log: noop,
    error: noop,
    warn: noop,
    info: noop,
    debug: noop,
    trace: noop,
    child: noop,
  },
  subnav: {
    set: noop,
    schema: [],
    Schema: noop,
  },
  actionBar: {
    notifications: {
      set: noop,
    },
  },
  globalnav: {
    setIsHidden: noop,
    isHidden: false,
  },
  session: {
    addAllyId: noop,
    data: null,
    status: 'Unauthenticated',
    delSession: noop,
    setSession: noop,
    requireAuth: noop,
    fetchLegacySession: noop,
  },
  utils: {
    fetch: {
      assets: noop,
      ACS: noop,
      CAPI: noop,
    },
    openHelpModal: noop,
    setHelpModalState: noop,
  },
  query: {},
  transmitRef: {
    useTransmit: noop,
    logout: noop,
    rehydrate: noop,
    loginWithUser: noop,
    forgotPassword: noop,
    transferTicket: noop,
    refreshAccessToken: noop,
    legacySession: noop,
    cenlarSso: noop,
    onlineEnrollment: noop,
    forgotUsername: noop,
    recoverPassword: noop,
    enrollGuest: noop,
    addAllyId: noop,
    getSecurityProfile: noop,
    updateSecurityProfile: noop,
  },
  browserHistory: noop,
  redirectToMortgage: noop,
})

export const HostServicesContext = React.createContext<HostServices>(
  defaultHostServices(),
)

export function useHostServices(): HostServices {
  return useContext(HostServicesContext)
}
